import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { TreeTableComponent } from 'src/app/AppBaseComponents/tree-table/tree-table.component';
import { ButtonIcon, OrgStructureNode } from 'src/app/Inteface/tree-node';
import { AdministrationService } from 'src/app/Services/administration.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'ze-org-structure-view',
  templateUrl: './org-structure-view.component.html',
  styleUrls: ['./org-structure-view.component.scss']
})
export class OrgStructureViewComponent implements OnInit {

  @ViewChild(TreeTableComponent, {static: false}) treeTableComponent: TreeTableComponent;

  treeData: OrgStructureNode[];
  loading: boolean = true;
  username: string;
  displayedColumns: string[] = ['name', 'icons'];
  error: string = '';
  
  constructor(private administrationService: AdministrationService,
    private _sharedService: SharedService,
    private notifyService: NotifyService) {
  }

  transformer = (node: any, level: number) => {
    return {
      expandable: !!node.departments && node.departments.length > 0,
      name: node.name,
      id: node.id,
      icons: node.icons,
      level: level,
    };
  };

  ngOnInit() {
    let currentUser1 = JSON.parse(localStorage.getItem("currentUser")).token;
    this.username = this.parseJwt(JSON.stringify(currentUser1)).sub;

    this.administrationService.getOrgStructureByUsername(this.username).subscribe(
      data => {
        this.error = '';
        if(data != null && data != undefined) {
          data.icons = this.createHeaderIcons(data.id, data.type, data.name, "DEPARTMENT");
        }
        this.addIcons(data);
        this.treeData = [data];
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
      },
      error => {
        this.error = error == 'Invalid organisation' ? error : 'Internal server error';
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
      }
    );
  }

  createHeaderIcons(id: string, type: string, orgName: string, createType: string): ButtonIcon[] {
    let addIcon: ButtonIcon = {
      name: "add",
      displayName: "Add",
      tooltip: "Add",
      disabled: false,
      onClick: () => this.onAddClick(id, type, orgName, createType)
    };
    return [addIcon];
  }

  createIcons(id: string, type: string, name: string): ButtonIcon[] {
    let deleteIcon: ButtonIcon = {
      name: "delete",
      tooltip: "Delete",
      hidden: true,
      onClick: () => this.onDeleteClick(id, type)
    };
    let editIcon: ButtonIcon = {
      name: "edit",
      tooltip: "Edit",
      disabled: false,
      onClick: () => this.onEditClick(id, type)
    };
    let addIcon: ButtonIcon = {
      name: "add",
      tooltip: "Add",
      disabled: false,
      onClick: () => this.onAddClick(id, type, name, "DEPARTMENT")
    };
    return [deleteIcon, editIcon, addIcon];
  }

  onEditClick(id: string, type: string) {
    if (type === "DEPARTMENT") {
      this.editDepartmentUI(id);
    } else if (type === "ORGANISATION") {

    }
  }

  editDepartmentUI(id: string) {
    this._sharedService.loaderHide.emit(true);
    this.administrationService.getDepartmentById(id).subscribe(
      data => {
        const formConfig = [
          { type: 'text', name: 'name', label: 'Name', required: true, placeholder: "Enter Name", value: data["name"] },
          { type: 'textarea', name: 'desc', label: 'Description', placeholder: "Type Description here", value: data["desc"] }
        ];
        this._sharedService.openOverlayFormEvent.emit([true, formConfig, "Edit Department", (form) => this.editDepartment(form, data)]);
        this._sharedService.loaderHide.emit(false);
      },
      error => {
        this.notifyService.notify('error', 'Failed', error == 'Invalid department' ? error : 'Error in fetching department details');
        this._sharedService.loaderHide.emit(false);
      }
    );
  }

  editDepartment(form: FormGroup, dep: any): Observable<any> {
    this._sharedService.loaderHide.emit(true);
    return new Observable((observer) => {
      this.administrationService.editDepartment(form, dep).subscribe(
        data => {
          this._sharedService.loaderHide.emit(false);
          this.notifyService.notify('success', 'Success', "Department edited Successfully");
          observer.next(false);
          observer.complete();
          const editedNode = this.findNodeById(this.treeData, data._id);
          if(editedNode) {
            editedNode.name = data.name
            this.treeTableComponent.refreshNode(editedNode, "departments");
          }
        },
        error => {
          this._sharedService.loaderHide.emit(false);
          this.notifyService.notify('error', 'Failed', error);
          observer.error(error);
        }
      );
    });
  }

  onDeleteClick(id: string, type: string) {
    if (type === "ORGANISATION") {

    } else if (type === "DEPARTMENT") {
      this.deleteDepartment(id);
    }
  }

  deleteDepartment(id: string) {
    this._sharedService.loaderHide.emit(true);
    this.administrationService.deleteDepartmentById(id).subscribe(
      data => {
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('success', 'Success', "Department deleted Successfully");
        const deletedParentNode = this.findNodeById(this.treeData, data.parent_id);
        if(deletedParentNode) {
          const indexToRemove = deletedParentNode.departments.findIndex(dep => dep.id === id);
          if (indexToRemove !== -1) {
            deletedParentNode.departments.splice(indexToRemove, 1);
            this.treeTableComponent.refreshNode(deletedParentNode, "departments");
          }
        }
      },
      error => {
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('error', 'Failed', error);
      }
    );
  }

  onAddClick(id: string, type: string, name: string, createType: string) {
    if(createType === "DEPARTMENT") {
      const formConfig = [
        { type: 'text', name: 'name', label: 'Name', required: true, placeholder: "Enter Name" },
        { type: 'textarea', name: 'desc', label: 'Description', placeholder: "Type Description here" },
        { type: 'textmsg', name: 'msg', msg: 'This unit will be added under', value: name }
      ];
      this._sharedService.openOverlayFormEvent.emit([true, formConfig, "Add Details", (form) => this.addDepartment(form, id, type)]);
    }
  }

  addDepartment(form: FormGroup, id: string, type: string): Observable<any> {
    this._sharedService.loaderHide.emit(true);
    return new Observable((observer) => {
      this.administrationService.addDepartment(form, id, type).subscribe(
        data => {
          this._sharedService.loaderHide.emit(false);
          this.notifyService.notify('success', 'Success', "Department added Successfully");
          observer.next(false);
          observer.complete();
          const parentNode = this.findNodeById(this.treeData, data.parent_id);
          if(parentNode) {
            let newDep: OrgStructureNode = {
              id: data._id,
              name: data.name,
              type: "DEPARTMENT",
              path: parentNode.path + ":" + data._id,
              icons: this.createIcons(data._id, "DEPARTMENT", data.name)
            };
            if(parentNode.departments) {              
              parentNode.departments.push(newDep);
            } else {
              parentNode.departments = [newDep];
            }
            this.treeTableComponent.refreshNode(parentNode, "departments");
          }
        },
        error => {
          this._sharedService.loaderHide.emit(false);
          this.notifyService.notify('error', 'Failed', error);
          observer.error(error);
        }
      );
    });
  }

  findNodeById(root: OrgStructureNode[], targetId: string): OrgStructureNode | null {
    for (const node of root) {
      if (node.id === targetId) {
        return node; // Found the node with the specified ID
      }  
      if (node.departments) {
        const foundInChildren = this.findNodeById(node.departments, targetId);
        if (foundInChildren) {
          return foundInChildren; // Node found in children
        }
      }
    }  
    return null; // Node with specified ID not found
  }

  addIcons(structureNode: OrgStructureNode): void {
    if(structureNode != null && structureNode.departments != null && structureNode.departments.length> 0) {
      structureNode.departments.forEach(department => {
        if(department.departments != null && department.departments.length> 0) {
          this.addIcons(department);
        }
        department.icons = this.createIcons(department.id, department.type, department.name);
      });
    }
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

}
